module.exports = __webpack_public_path__ + "img/hikari_ost.b346faaa.png";